export const TEXT: { [key: string]: { [key: string]: string } } = {
    'es': {
        //HEADER
        'blog': 'BLOG',
        'bespoken': 'BESPOKEN',
        'baby_and_you': 'TU Y TU BEBÉ',
        'subscribe': 'SUBSCRIBETE',
        'who_am_i': 'QUIEN SOY',
        'hygge': 'HYGGE',
        'contact': 'CONTACTO',
        'journal': 'DIARIO',
        'what_ive_learned': 'LO QUE HE APRENDIDO',
        'life_in_north': 'VIDA EN EL NORTE',
        'discover': 'DESCUBRE',
        'shop': 'TIENDA',
        'the_branch': 'LA MARCA',
        'travel_and_contemplation': 'VIAJE Y CONTEMPLACIÓN',
        'mindfulness': 'MINDFULNESS',
        'videos': 'VIDEOS',
        'about': 'SOBRE MI',
        'search': 'Buscar',

        //LOGIN
        'login': 'INICIAR SESIÓN',
        'email': 'Email',
        'password': 'Contraseña',

        //POSTS
        'latest_posts': 'ÚLTIMAS PUBLICACIONES',

        //FOOTER
        'privacy': 'Política',
        'privacy_policy': 'Política de Privacidad',
        'contact_me': 'Contáctame',
        'about2': 'Sobre mí',

        //TOASTS
        'see_you_later': 'Hasta pronto!',
        'deleting_post': 'Eliminando publicación...',
        'link_copied': 'Link copiado en el portapapeles',
        'updating': 'Actualizando...',
        'saving': 'Guardando...',
        'saving_ok': 'Post guardado. Redirigiendo...',
        'error_updating': 'Error guardando post. Prueba nuevamente mas tarde',
        'invalid_image_url': 'Utiliza una URL válida',
        'subscribing': 'Subscribiendo...',
        'subscribe_ok': 'Gracias por ser parte!',
        'subscribe_error': 'Error en la subscripción. Prueba nuevamente mas tarde',

        //SUBSCRIBE
        'full_name': `Tu nombre completo`,
        'subscribe_info': `  <h2>Subscríbete</h2>
        <h3>Suscríbase a Angelita y manténgase actualizado con los últimos contenidos, noticias y ofertas especiales de BESPOKEN.
        </h3>
        <h4>Como suscriptor, recibirás:</h4>
        <ul>
            <li>Actualizaciones periódicas sobre las últimas publicaciones y artículos del blog
            </li>
            <li>Acceso exclusivo a contenido exclusivo para suscriptores
            </li>
            <li>Primeros dibs en nuestras ofertas especiales y promociones de BESPOKEN
            </li>
            <li>La opción de darse de baja en cualquier momento
            </li>
        </ul>
        <br />
        <h4>¡Todo esto gratis!
        </h4>
        <br /> <br /> <br /> <br />
        <p>Para suscribirse, simplemente ingrese su dirección de correo electrónico en el formulario y haga clic en "Suscribirse". Le enviaremos un correo electrónico de confirmación para verificar su dirección de correo electrónico y confirmar su suscripción.

            <br />By subscribing, you agree to receive emails and newsletters from Angelita. We will never share or sell your email address to third-party organizations. You can unsubscribe at any time by clicking the "unsubscribe" link at the bottom of our emails.

            <br /> <br />Thank you for subscribing to Angelita! I look forward to sharing my latest content and news with you.
        </p>`,


        //CONTACT
        'your_name': 'Tu nombre',
        'your_email': 'Tu email',
        'your_message': 'Tu mensaje',
        'sent': 'Enviar',
        'thank_you_msg': 'Gracias! 😊',
        'will_respond': 'Te responderé lo antes posible.',
        'have_a_question': `¿Tienes alguna pregunta, comentario o inquietud? Envíame un mensaje y me pondré en contacto contigo lo antes posible.`,
        'submit_policy': `Al enviar este formulario, usted acepta nuestra Política de privacidad. Solo usaré su información para responder a su consulta y no la compartiré ni la venderé a organizaciones de terceros.`,

        //PRIVACY POLICY
        'privacy_policies': `<h1 className="privacy__title">Política de privacidad</h1>
        <h2 className="policy__subtitle">Introducción</h2>
        <p className="policy__text">En Angelita, nos tomamos la privacidad en serio. Esta política de privacidad explica cómo recopilamos, usamos y protegemos tu información personal cuando visitas nuestra página (el "Sitio").</p>
    
        <h2 className="policy__subtitle">¿Qué información personal recopilamos?</h2>
        <p className="policy__text">Cuando visitas el Sitio, recopilamos automáticamente cierta información sobre tu dispositivo, incluida información sobre tu navegador web, dirección IP, zona horaria y algunas de las cookies que se instalan en tu dispositivo. Además, mientras navegas por el Sitio, recopilamos información sobre las páginas web o productos individuales que ves, qué sitios web o términos de búsqueda te llevaron al Sitio, e información sobre cómo interactúas con el Sitio.</p>
    
        <h2 className="policy__subtitle">¿Cómo utilizamos tu información personal?</h2>
        <p className="policy__text">Utilizamos la información que recopilamos para ayudarnos a detectar posibles riesgos y fraudes (en particular, tu dirección IP), y más en general, para mejorar y optimizar nuestro Sitio (por ejemplo, mediante la generación de análisis sobre cómo nuestros clientes navegan e interactúan con el Sitio, y para evaluar el éxito de nuestras campañas de marketing y publicidad).</p>
    
        <h2 className="policy__subtitle">Compartir tu información personal</h2>
        <p className="policy__text">No compartimos tu información personal con terceros. Sin embargo, podemos utilizar servicios de terceros para ayudarnos a operar nuestro Sitio, como Google Analytics, que puede recopilar, usar y compartir tu información para ayudarnos a comprender cómo se utiliza nuestro Sitio. Puedes leer más sobre cómo Google utiliza tu información personal aquí: <a href="https://www.google.com/intl/es/policies/privacy/">https://www.google.com/intl/es/policies/privacy/</a>. También puedes optar por no participar en Google Analytics aquí: <a href="https://tools.google.com/dlpage/gaoptout">https://tools.google.com/dlpage/gaoptout</a>.</p>
    
        <h2 className="policy__subtitle">Seguridad</h2>
        <p className="policy__text">Tomamos precauciones razonables para proteger tu información personal y evitar el acceso, uso o divulgación no autorizados. Sin embargo, no podemos garantizar que tu información personal estará siempre segura, ya que ningún método de transmisión a través de Internet o almacenamiento electrónico es 100% seguro.</p>
    
        <h2 className="policy__subtitle">Cambios</h2>
        <p className="policy__text">Es posible que actualicemos esta política de privacidad de vez en cuando para reflejar, por ejemplo, cambios en nuestras prácticas u otras razones operativas, legales o regulatorias.</p>
    
        <h2 className="policy__subtitle">Contáctanos</h2>
        <p className="policy__text">Para obtener más información sobre nuestras prácticas de privacidad, si tienes preguntas o si deseas presentar una queja, contáctanos por correo electrónico a <a href="mailto:info@angelasanguino.com">info@angelasanguino.com</a>.</p>`,

        //ABOUT
        'about_me': `Sobre mí`,
        'about_me_body': `<p className="about__text">¡Hola, me llamo Angela Sanguino García, para los que quieran “Angelita”.
        <p className="about__text">Estudio psicología hace 28 años, me gradué como psicóloga clínica cognitivo-conductual, junto con una especialización en psicología del consumidor. De ahí en adelante me dediqué a cuestionar todo lo que había aprendido porque me quedaba sumamente corta con el abordaje conductual, así que gracias a los fundamentos que me dió la carrera profesional, pude elegir y discriminar muy bien entre información común e información especializada y empecé a atar cabos que me llevaban siempre al estudio del ser y de la existencia desde integración de la triada cuerpo | alma / psiquis | espíritu. Así que mi abordaje preferido es el ontológico y el integrativo y con él he podido direccionar almas desesperadas a una solución absoluta que no tiene opuestos ni contradictorios y en cuyo encuentro solo hay fuerza, poder, paz, dicha y descanso.</p>`,
    },
    'en': {
        //HEADER
        'blog': 'BLOG',
        'bespoken': 'BESPOKEN',
        'baby_and_you': 'BABY & YOU',
        'subscribe': 'SUBSCRIBE',
        'who_am_i': 'WHO AM I',
        'contact': 'CONTACT',
        'hygge': 'HYGGE',
        'discover': 'DISCOVER',
        'journal': 'JOURNAL',
        'what_ive_learned': `WHAT I'VE LEARNED`,
        'life_in_north': 'LIFE IN THE NORTH',
        'shop': 'SHOP',
        'the_branch': 'THE BRANCH',
        'travel_and_contemplation': 'TRAVEL & CONTEMPLATION',
        'mindfulness': 'MINDFULNESS',
        'videos': 'VIDEOS',
        'about': 'ABOUT',
        'search': 'Search',

        //LOGIN
        'login': 'LOGIN',
        'email': 'Email',
        'password': 'Password',

        //POSTS
        'latest_posts': 'LATEST POSTS',

        //FOOTER
        'privacy': 'Policy',
        'privacy_policy': 'Privacy Policy',
        'contact_me': 'Contact me',
        'about2': 'About',

        //TOASTS
        'see_you_later': 'See you later!',
        'deleting_post': 'Deleting post...',
        'link_copied': 'Link copied to clipboard',
        'updating': 'Updating...',
        'saving': 'Saving...',
        'saving_ok': 'Post saved successfully. Redirecting...',
        'error_saving': 'Error saving post, try again later',
        'invalid_image_url': 'Write a valid image URL',
        'subscribing': 'Subscribing...',
        'subscribe_ok': 'Thank you for joining us!',
        'subscribe_error': 'Error subscribing, try again later',

        //SUBSCRIBE
        'full_name': `Your full name`,
        'subscribe_info': `  <h2>Subscribe</h2>
        <h3>Subscribe to Angelita and stay up-to-date with the latest content, news, and special offers from BESPOKEN.</h3>
        <h4>As a subscriber, you'll receive:</h4>
        <ul>
            <li>Regular updates on the latest blog posts and articles</li>
            <li>Exclusive access to subscriber-only content</li>
            <li>First dibs on our special offers and promotions from BESPOKEN</li>
            <li>The option to unsubscribe at any time</li>
        </ul>
        <br />
        <h4>All this for free!</h4>
        <br /> <br /> <br /> <br />
        <p>To subscribe, simply enter your email address in the form and click "Subscribe". We'll send you a confirmation email to verify your email address and confirm your subscription.
            <br />Al suscribirte, aceptas recibir correos electrónicos y boletines de Angelita. Nunca compartiremos ni venderemos su dirección de correo electrónico a organizaciones de terceros. Puede darse de baja en cualquier momento haciendo clic en el enlace "cancelar suscripción" en la parte inferior de nuestros correos electrónicos.

            <br /> <br />¡Gracias por suscribirte a Angelita! Espero poder compartir mis últimos contenidos y noticias contigo.
        </p>`,

        //CONTACT
        'your_name': 'Your name',
        'your_email': 'Your email',
        'your_message': 'Your message',
        'sent': 'Sent',
        'thank_you_msg': 'Thank you! 😊',
        'will_respond': 'I will respong as soon as I can.',
        'have_a_question': `Have a question, comment, or concern? Please fill out the form and I'll get back to you as soon as possible.`,
        'submit_policy': `By submitting this form, you agree to our Privacy Policy. I will only use your information to respond to your inquiry and will not share or sell it to third-party organizations.`,

        //PRIVACY POLICY
        'privacy_policies': ` <h1 className="privacy__title">Privacy Policy</h1>
        <h2 className="policy__subtitle">Introduction</h2>
        <p className="policy__text">At Angelita, we take privacy seriously. This privacy policy explains how we collect, use, and protect your personal information when you visit our site (the “Site”).</p>

        <h2 className="policy__subtitle">What personal information do we collect?</h2>
        <p className="policy__text">When you visit the Site, we automatically collect certain information about your device, including information about your web browser, IP address, time zone, and some of the cookies that are installed on your device. Additionally, as you browse the Site, we collect information about the individual web pages or products that you view, what websites or search terms referred you to the Site, and information about how you interact with the Site.</p>

        <h2 className="policy__subtitle">How do we use your personal information?</h2>
        <p className="policy__text">We use the information that we collect to help us screen for potential risk and fraud (in particular, your IP address), and more generally to improve and optimize our Site (for example, by generating analytics about how our customers browse and interact with the Site, and to assess the success of our marketing and advertising campaigns).</p>

        <h2 className="policy__subtitle">Sharing your personal information</h2>
        <p className="policy__text">We do not share your personal information with any third parties. However, we may use third-party services to help us operate our Site, such as Google Analytics, which may collect, use and share your information to help us understand how our Site is being used. You can read more about how Google uses your personal information here: https://www.google.com/intl/en/policies/privacy/. You can also opt-out of Google Analytics here: https://tools.google.com/dlpage/gaoptout.</p>

        <h2 className="policy__subtitle">Security</h2>
        <p className="policy__text">We take reasonable precautions to protect your personal information and to prevent unauthorized access, use, or disclosure. However, we cannot guarantee that your personal information will always be secure, as no method of transmission over the Internet or electronic storage is 100% secure.</p>

        <h2 className="policy__subtitle">Changes</h2>
        <p className="policy__text">We may update this privacy policy from time to time in order to reflect, for example, changes to our practices or for other operational, legal, or regulatory reasons.</p>

        <h2 className="policy__subtitle">Contact us</h2>
        <p className="policy__text">For more information about our privacy practices, if you have questions, or if you would like to make a complaint, please contact us by email at <a href="mailto:info@angelasanguino.com">info@angelasanguino.com</a>.</p>`,

        //ABOUT
        'about_me': `About me`,
        'about_me_body': ` <p className="about__text">Hi, I'm Angela Sanguino, and welcome to my blog! I'm a passionate writer who loves to share her ideas and experiences with the world. I started this blog as a way to connect with other like-minded people and to create a space where we can all learn and grow together.</p>
        <p className="about__text">I have a degree in Tourism & Hospitality with deep focus in Service and Event Management, and have been writing for over 5 years. I'm constantly seeking out new ideas and inspiration for my writing, and I love to explore different topics and perspectives. On this blog, you'll find a mix of personal stories, lifestyle tips, and thought-provoking articles on a variety of subjects.</p>
        <p className="about__text">When I'm not writing, I enjoy spending time with my family, reading books, and traveling to new places. I'm also a big fan of painting meditation, and I believe in the power of faith and mindfulness to transform our lives.</p>
        <p className="about__text">Thank you for visiting my blog, and I hope you enjoy reading my posts as much as I enjoy writing them!</p>`,
    }
}